export default __webpack_public_path__ + "static/media/banner.360838be.jpg";